/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { createDefaultGridModel } from '@gh/common-internal-shared';
import { NumberTypes, State } from '@gh/common-shared';
import { TranslationService } from '@gh/core-mls';
import {
  buildNumberColumn,
  GridModel,
  GridOptionsExt,
  ManualGridDefinitionWithModel,
} from '@gh/core-ui-grid';
import { ColDef } from 'ag-grid-community';
import { get } from 'lodash';
import { getJeComponentItemId } from '../../../resources/job-estimate-details.model';
import {
  JeDetailsState,
  queryJeCostCenter,
  queryJeEditable,
  queryJeUomRefItem,
} from '../je-details.state';

@Injectable()
export class JeDetailsComponentItemGridDefinition extends ManualGridDefinitionWithModel {

  constructor(private translationService: TranslationService,
              private state: State<JeDetailsState>) {
    super();
  }

  buildGridModel(): GridModel {
    return createDefaultGridModel({
      editable: this.state.select(queryJeEditable),
      getId: getJeComponentItemId,
    });
  }

  buildGridOptions(): GridOptionsExt {
    return {
      defaultColDef: {
        sortable: false,
      },
    };
  }

  buildColumnDefs(): ColDef[] {
    return [{
      field: 'code',
      headerName: this.translationService.get('lbl_code'),
      width: 150,
    }, {
      field: 'description',
      headerName: this.translationService.get('lbl_description'),
      width: 150,
    }, {
      field: 'costCenter',
      headerName: this.translationService.get('lbl_cost_center'),
      width: 150,
      valueFormatter: ({ data }: { data: any }) =>
        get(this.state.project(queryJeCostCenter, data.costCenterId), 'code', '').toString(),
    }, {
      field: 'quantityComponent',
      headerName: this.translationService.get('lbl_qty'),
      width: 150,
      ...buildNumberColumn(NumberTypes.Quantity),
    }, {
      field: 'cost',
      headerName: this.translationService.get('lbl_cost_dollar'),
      width: 150,
      ...buildNumberColumn(NumberTypes.Price),
    }, {
      field: 'uomCode',
      headerName: this.translationService.get('lbl_uom_abbreviation'),
      width: 150,
      valueFormatter: ({ data }: { data: any }) => get(this.state.project(queryJeUomRefItem, data.uomId), 'code', ''),
    }, {
      field: 'extensionComponent',
      headerName: this.translationService.get('lbl_extension_dollar'),
      width: 150,
      ...buildNumberColumn(NumberTypes.Price),
    }];
  }
}
